import React from "react";
import { Button } from "semantic-ui-react";
import { Modal } from "../../components";
import WhoCanReviewModalContent from "./WhoCanReviewModal";

interface Props {
  item: server.dto.DocumentChecklistItem
  whoCanReviewApi: typeof window.CoreApi.Checklist.WhoCanReviewESignChecklistItem;
}

const ChecklistNotAnsweredNoPermissionRowCard = (props: Props) => {
  const [whoCanEdit, setWhoCanEdit] = React.useState<server.dto.UserSmall[]>(undefined);
  const [loadingWhoCanEdit, setLoadingWhoCanEdit] = React.useState(false);

  const loadWhoCanEdit = async () => {
    setLoadingWhoCanEdit(true);
    const result = await props.whoCanReviewApi(props.item.documentChecklistItemId);
    setWhoCanEdit(result.data.data.users);
    setLoadingWhoCanEdit(false);
  };

  const { item } = props;
  return <>
    <div>
      <div className="grow1">
        <div>
          <h3>{item.question}</h3>
        </div>
      </div>
      <div>
        <Button className="blue" loading={loadingWhoCanEdit} onClick={loadWhoCanEdit}>
          {RESX.Checklist.WaitingForReview}
        </Button>
      </div>
    </div>

    <Modal
      title={RESX.Checklist.WhoCanReview}
      isOpen={whoCanEdit != null}
      handleClose={() => { setWhoCanEdit(undefined); }}
      width="small"
      height={500}
    >
      {((whoCanEdit != null) && (whoCanEdit.length === 0)) && <div className="grow1 flex justify-center align-center" style={{ textAlign: "center" }}>
        <span className="s1_red huge_text">
          {RESX.Checklist.NoUsersHavePermissionToReview}<br />
          <br />
          {RESX.ExceptionMessage.AskYourSystemAdministrator}
        </span>
      </div>}
      {(whoCanEdit != null && whoCanEdit.length > 0) && <WhoCanReviewModalContent
        users={whoCanEdit}
      />}
    </Modal >
  </ >;
};

export default ChecklistNotAnsweredNoPermissionRowCard;